export const ALL_USERS = 'https://jsonplaceholder.typicode.com/users';
export const ADD_PROPERTY = '/v1/property/save-property';
export const DELETE_PROPERTY = '/v1/property/delete-property';
export const FETCH_PROPERTY_DETAILS = '/v1/property/fetch-property-detail';
export const FETCH_IMAGE = '/v1/property/get-image';
export const UPLOAD_FILE = '/v1/property/upload-large-files';
export const FETCH_ALL_PROPERTY = '/v1/property/fetch-all-properties';
export const FETCH_PROPERTY_TYPE = '/v1/property-master/fetch-property-type';
export const FETCH_WATER_SOURCE = '/v1/property-master/fetch-water-source-type';
export const FETCH_ROAD_TYPE = '/v1/property-master/fetch-road-type';
export const FETCH_CRZ_TYPE = '/v1/property-master/fetch-crz-type';
export const FETCH_REQUIRED_DOCUMENTS = '/v1/property/fetch-required-documents';
export const AUDIT_LOGIN = '/v1/users/loginaudit';
export const LOGIN = '/v1/users/login';
export const VERIFY_ACCESS_TOKEN = '/v1/users/verify-access-token';
export const LOGOUT = '/v1/logout';
export const GENERATE_BEARER_TOKEN = '/v1/generate-token';
export const GET_ALL_USER_ROLES = '/v1/roles';
export const GET_USER_ROLES = '/v1/users';

export const ROLES_LIST = '/v1/roles';
export const ENABLE_OR_DISABLE_ROLE = '/v1/roles/enable-or-disable';
export const ADD_EDIT_ROLES = '/v1/roles';
export const REPORT_PDF = '/v1/reports?format=pdf';
export const REPORT_EXCEL = '/v1/reports?format=excel';
export const MASTER_VERTICAL = '/v1/vertical/';
export const GET_SKILLS = '/v1/skills';
export const MASTER_DEPARTMENT = '/v1/department';
export const MASTER_DESIGNATION = '/v1/designation';
export const ENABLE_OR_DISABLE_SKILLS = '/v1/skills/enable-or-disable';
export const CERTIFICATIONS_LIST = '/v1/certification';
export const ENABLE_DISABLE_CERTIFICATION
= '/v1/certification/enable-or-disable';
export const ADD_EDIT_CERTIFICATION = '/v1/certification';
export const CERTIFICATION_MAP_LIST = '/v1/certification-map';
export const ADD_EDIT_TARGETS = '/v1/targets/';
export const SKILL_MAP_REPORT_PDF = '/v1/skill-map/reports?format=pdf';
export const SKILL_MAP_REPORT_EXCEL = '/v1/skill-map/reports?format=excel';
export const DELETE_CERTIFICATION_MAP = '/v1/certification-map/{mapId}';
export const CERTIFICATION_MAP_REPORT_PDF
= '/v1/certification-map/reports?format=pdf';
export const CERTIFICATION_MAP_REPORT_EXCEL
 = '/v1/certification-map/reports?format=excel';
export const GET_TARGETS = '/v1/targets/{year}';
export const CERTIFICATION_VERTICAL_COUNT = '/v1/certification-map/count';
export const DELETE_TARGET = '/v1/targets/delete';
export const ADD_EDIT_CERTIFICATION_MAP = '/v1/certification-map';
export const FETCH_USER_INFO = '/v1/users';
export const FETCH_USER_PROFILE_PICTURE = '/v1/users/profile-picture';

export const RECOGNITIONS_LIST = '/v1/recognitions';
export const SKILL_MAP = '/v1/skill-map';
export const SKILL_MAP_FILTER = '/v1/skill-map-filter';
export const ROLE_MAP_LIST = '/v1/role-map';
export const DELETE_SKILL_MAP = '/v1/skill-map/{mapId}';
export const SKILL_VERTICAL_DEPARTMENT_MAP = '/v1/skill-vertical-department-map';
// eslint-disable-next-line id-length
export const CERTIFICATION_OVERVIEW_DOWNLOAD_URL
= '/v1/certification-overview/reports/';
export const STAFF_AUGMENTATION_DOWNLOAD_URL
= '/v1/staff-augmentation/reports';
export const AWARDS_LIST = '/v1/awards';
export const DRI_LIST = '/v1/dri';
export const KPI = '/v1/kpi';
export const KPI_CATEGORY_MASTER = '/v1/kpi-category-master';
export const KPI_TARGET_FORMAT = '/v1/kpi-target-format';
export const KPI_MASTER = '/v1/kpi-master';
export const PERFORMANCE_PERIOD_MASTER = '/v1/performance-period-master';
export const PROJECT_DETAILS = '/projects';
export const DEAL_ROLE_MASTER = '/v1/roles?isDtRoles=true';
export const ENABLE_OR_DISABLE_DEAL_ROLE = '/v1/roles/enable-or-disable';
export const DEAL_STATUS_LIST = '/v1/deal-master/status';
export const LOST_DROPPED_STATUS = '/v1/lost-dropped-status';
export const PERFORMANCE_PERIOD_DETAILS = '/v1/performance-period-master';
export const PERFORMANCE_KPI_DETAILS = '/v1/user-kpi-scores';
export const KPI_PERFORMANCE_CYCLE = '/v1/fetch-kpi-performance-cycle';
export const DEAL_TRANSITION_FORM = '/v1/deal-transition-form';
export const DEAL_DETAIL_VIEW = '/v1/deal-deatiled-view';
export const DEAL_PARAMETERS_MASTER = '/v1/dealParameters';
export const DEAL_PARAMETERS_SLA = '/v1/dealParameters/sla';
export const DEAL_PARAMETERS_WORKFLOW = '/v1/dealParameters/workflow';
export const DASHBOARD = '/v1/dashboard';
export const CERTIFICATION_CATEGORY_MASTER = '/v1/certification-category-master';
export const COLUMN_CUSTOMIZATION = '/v1/customcolumn/column';
export const GET_COLUMN_DATA = '/v1/customcolumn/getcolumn';
export const DEAL_TRANSITION_DETAILS = '/v1/deal-transition-details';
export const DEAL_SAVE_FOR_LATER = '/v1/save-later-deal-transition-deatils';
export const GET_TABULAR_VIEW = '/v1/tabular-view';
export const HIRING_DETAILS = '/v1/hiring-details';
export const BE_EFFORT = '/v1/be-effort';
export const BE_EFFORT_WITH_BULK_EDIT = '/v1/be-effort/bulk-edit-deal-be-effort';
export const TRIGGER_EFFORT_UPLOAD = '/v1/jira-manual-effort-upload';
export const TRIGGER_LEAVE_UPLOAD = '/v1/zoho-manual-leave-upload';
export const EFFORT_HISTORY_LIST = '/v1/scheduler-history/?scheduler-category=jira-work-log';
export const LEAVE_HISTORY_LIST = '/v1/scheduler-history/?scheduler-category=leave-details';
export const UPLOAD_CONFIG_DATES = '/v1/data-upload-configuration';
export const BASE_EFFORT = '/v1/base-effort';
export const TECHNICAL_COMPLEXITY_EFFORT = '/v1/tech-buffer';
export const EXTERNAL_INTEGRATION_EFFORT = '/v1/external-integration-buffer';
export const REQUIREMENT_CLARITY_EFFORT = '/v1/clarity-buffer';
export const COMMERCIAL_WORKFLOW = '/v1/commercial-workflows';
export const EFFORT_WORKFLOW = '/v1/effort-workflows';
export const DASHBOARD_COLLECTIONS = '/v1/collection-dashboard';
export const MIS_RESELLER_REPORT_TABLE = '/v1/reseller-invoice';
export const MIS_RESELLER_REPORT_TABLE_EXPORT = '/v1/reseller-invoice/export';
export const CLOUD_COST = '/v1/cloud-cost';
export const GET_CLOUD_COST = '/v1/get-cloud-cost';
export const GET_CLOUD_COST_DETAILS = '/v1/get-cloud-cost-details';
export const UPDATE_CLOUD_COST = '/v1/update-cloud-cost';
export const STAFFING_STATUS = '/v1/staffing-status';
export const STAFFING_STATUS_MASTER = '/v1/staffing-status';
export const STAFFING_LOST_DROPPED_STATUS = '/v1/lost-dropped-status';
export const STAFFING_STATUS_MASTER_SWITCH = '/v1/staffing-status/{staffId}';
export const DASHBOARD_COLLECTIONS_DSO = '/v1/collection-dashboard/dso';
export const BASE_EFFORTS = '/v1/base-effort?type=base&is_active=true';
export const BASE_EFFORTS_SAVE = '/v1/base-effort';
export const BASE_EFFORTS_EDIT = '/v1/base-effort';
export const BASE_EFFORTS_DELETE = '/v1/base-effort?id=1';
export const TASK_MASTER = '/v1/task-master';
export const PROJECT_MANAGEMENT_MASTERS = '/v1/project-management-masters';
export const CODE_COVERAGE = '/v1/code-coverage-masters';
export const TEST_MASTER = '/v1/test_master';
export const RESELLER_INVOICE_PROJECTION_IMPORT = '/v1/reseller-invoice/import';

export const GET_STAFFING_COST = '/v1/manPower-cost';
export const GET_STAFFING_COST_DETAILS = '/v1/get-manPower-cost';
export const CREATE_MAN_POWER_COST = '/v1/create-manPower-cost';
export const UPDATE_MAN_POWER_COST = '/v1/update-manPower-cost';
export const MAN_POWER_COST_CALCULATION = '/v1/manPower-cost-calculation';
export const TECH_BUFFER = '/v1/tech-buffer';
export const EXTERNAL_INTEGRATION_BUFFER = '/v1/external-integration-buffer';
export const CLARITY_BUFFER = '/v1/clarity-buffer';
export const MANUAL_ASSIGNMENT = '/v1/manual-assignment';
export const OVERALL_BUFFER = '/v1/over-all-buffer';
export const SOFTWARE_COST = '/v1/software-cost-be';
export const HARDWARE_COST = '/v1/hardware-costs';
export const TRAVEL_COST_CITIES = '/v1/cities';
export const TRAVEL_COST = '/v1/travel-costs';
export const CALCULATE_BASE_EFFORT = '/v1/be-effort/calculate';
export const STAFF_AUGEMENTATION = '/v1/staffing-augmentation';
export const FILE_UPLOAD_ENDPOINT = '/v1/file-upload';
export const EFFORT_HISTORY_LIST_File_UPLOAD = '/v1/scheduler-history/?scheduler-category=client-effort-log';
export const STAFF_REQUIREMENT = '/v1/resource-requirement';
export const PROJECT_OVERVIEW = '/v1/project-overview';
export const MIS_PMO_HEALTH_CHECK = '/v1/pmo-health-check';
export const REQUEST_RESOURCE = '/v1/resource-requirement';
export const RESOURCE__REQUIREMENT_REPORTS
 = '/v1/resource-requirement/reports';
export const OPPORTUNITIES_OVERVIEW_REPORTS = '/v1/staffing-opportunities-overview-report';
export const OPPORTUNITIES_REPORT_DOWNLOAD = '/v1/staffing-opportunity-report';

export const TECH_SESSIONS = '/v1/tech-sessions';


export const OTHER_EFFORTS = '/v1/deal_other_efforts';
export const OTHER_EFFORTS_SAVE = '/v1/deal_other_efforts';
export const OTHER_EFFORTS_EDIT = '/v1/deal_other_efforts';
export const OTHER_EFFORTS_DELETE = '/v1/deal_other_efforts';

export const STAFFING_COST = '/v1/staffingCost/deal';
export const STAFFING_COST_UPDATE = '/v1/staffingCost/deal';
export const UPLOAD_FILES = '/v1/upload/files';
export const REMOVE_FILES = '/v1/delete/files';


export const FE_EFFORT = '/v1/fe-effort';
export const FE_EFFORT_WITH_BULK_EDIT = '/v1/fe-effort/bulk-edit-deal-fe-effort';
export const CALCULATE_FE_BASE_EFFORT = '/v1/Fe-effort/calculate';
export const EFFORT_SUMMARY = '/v1/effortSummaryScreenBe';
export const EFFORT_SUMMARY_SUBMIT = '/v1/effort/deal';
export const GET_SKILLSET = '/v1/dealSkillsetScope';

export const SITE_CONFIGURATION = '/v1/site-configuration';

export const TECH_COST = '/v1/techCost';
export const GET_EFFORT_APPROVAL = '/v1/effort-approval-dashboard';
export const GET_DEAL_EFFORT_REVIEWERS = '/v1/deal-effort-approvals';

export const GET_TRAINING_DETAILS = '/v1/training-details';
export const GET_CLOSURE_REPORT = '/v1/staffing-closure-overview';
export const CLOSURE_OVERVIEW_REPORT = '/v1/closure-overview-report/download';
export const GET_PENDING_ONBOARDING_REPORT = '/v1/resources-pending-onborading';
export const PENDING_ONBOARDING_DOWNLOAD = '/v1/resources-pending-onborading/download';

export const GET_STAFFING_PENDING_POSITIONS = '/v1/staffing-pending-position-overview';
export const STAFFING_PENDING_POSITIONS_REPORT = '/v1/staffing-pending-positions-reports/download';
export const GET_LOST_DROPPED_OVERVIEW = '/v1/staffing-lost-dropped-overview';
export const GET_LOST_DROPPED_REPORT = '/v1/staffing-lost-dropped-report';
export const GET_SALES_MEMBER_OVERVIEW = '/v1/staffing-sales-member-overview';
export const GET_SALES_MEMBER_REPORT = '/v1/sales-member-overview-report';
export const GET_DELIVERY_MANAGER_OVERVIEW = '/v1/staffing-delivery-manger-overview';
export const GET_DELIVERY_MANAGER_REPORT = '/v1/delivery-manager-overview-report';
export const GET_ASSESSMENT_DETAILS = '/v1/assessment-details';
export const TRIGGER_LEAVE_SYNC = '/v1/sync-leave-data';
